import { graphql } from "gatsby"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import '../css/post.css';

import Layout from "../layouts"
// Aliased: "Head" is reserved for the Gatsby Head API export below, which must
// use that exact name. This import is the existing inline meta component.
import MetaHead from "../components/head"
import Sidebar from "../components/sidebar"
import RelatedPosts from "../components/related-posts"
import JsonLd from "../components/schema/JsonLd"
import {
  organizationNode,
  websiteNode,
  webPageNode,
  breadcrumbNode,
  articleNode,
  LOGO_URL,
} from "../components/schema/nodes"

import placeholder from "../images/default-blog.jpg";

class PostTemplate extends Component {
  render() {
    const mostRecent = this.props.data.mostRecent.nodes;
    const relatedPosts = this.props.data.relatedPosts.nodes;
    const { title, link, content, date, featuredImage, categories, seo } = this.props.data.wpPost;

    const shuffledPosts = relatedPosts.sort(() => 0.5 - Math.random());
    let selectedPosts = shuffledPosts.slice(0, 3);

    let categoryList = '';
if(categories && categories.nodes) {
  categories.nodes.forEach((cat, index) => {
    categoryList += index === 0 ? cat.name : ', ' + cat.name;
  });
}

    let featured = {
      url: placeholder,
      alt: 'Featured Image'
    }

    let featuredImageData = null;
    if (featuredImage && featuredImage.node) {
      const imageUrl = featuredImage.node.sourceUrl; // Do not encode it again
      // console.log(imageUrl);

      featured = {
        url: `https://www.roanokegroup.com/.netlify/images?url=${imageUrl}`,
        alt: featuredImage.node.altText ? featuredImage.node.altText : 'Featured Image'
      };
      // console.log(featured.url);

      // Get GatsbyImage data if available
      featuredImageData = featuredImage.node.localFile?.childImageSharp?.gatsbyImageData;
    }
    
    // @TODO: STEP #5: Use title and content in Gatsby.
    return (
      <Layout>
        <MetaHead title={seo.title} description={seo.metaDesc} meta={seo} />
        <div className="container blogSingle">
          <div className="grid smallGrid">
            <div className="col-sm-8 maincopy">
              <p className="blogDetails">{date} | {categoryList}</p>
              <div className="grid align-end">
                <div className="col-sm-8">
                  <h1>{title}</h1>
                </div>
                <div className="col-sm-4">
                  
                  <div className="socialBlog">
                    <span>Share This:</span>
                    <a rel="noreferrer" aria-label="Share on Facebook" target="_blank" href={"https://www.facebook.com/share.php?u="+link}><FontAwesomeIcon icon={faFacebookF} aria-hidden="true" /></a>
                    <a rel="noreferrer" aria-label="Share on Twitter" target="_blank" href={"http://twitter.com/share?url="+link+"&count=horizontal"}><FontAwesomeIcon icon={faTwitter} aria-hidden="true" /></a>
                    <a rel="noreferrer" aria-label="Share on LinkedIn" target="_blank" href={"https://www.linkedin.com/shareArticle?mini=true&url="+link+"&title="+title+"&summary=&source=LinkedIn"}><FontAwesomeIcon icon={faLinkedinIn} aria-hidden="true" /></a>
                    <a rel="noreferrer" aria-label="Share via email" href={"mailto:?subject="+title+"&body=Check%20out%20this%20article%20"+link}><FontAwesomeIcon icon={faEnvelope} aria-hidden="true" /></a>
                  </div>
                </div>
              </div>
              
            </div>
            <div className="col-sm-8 maincopy">
              {featuredImageData ? (
                <GatsbyImage
                  image={getImage(featuredImageData)}
                  alt={featured.alt}
                  className="flex-img mainImage"
          backgroundColor="transparent"
                />
              ) : (
                <img src={featured.url} alt={featured.alt} className="flex-img mainImage" />
              )}
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
              <div className="socialBlog" style={{'textAlign':'right'}}>
                <span>Share This:</span>
                <a rel="noreferrer" aria-label="Share on Facebook" target="_blank" href={"https://www.facebook.com/share.php?u="+link}><FontAwesomeIcon icon={faFacebookF} aria-hidden="true" /></a>
                <a rel="noreferrer" aria-label="Share on Twitter" target="_blank" href={"http://twitter.com/share?url="+link+"&count=horizontal"}><FontAwesomeIcon icon={faTwitter} aria-hidden="true" /></a>
                <a rel="noreferrer" aria-label="Share on LinkedIn" target="_blank" href={"https://www.linkedin.com/shareArticle?mini=true&url="+link+"&title="+title+"&summary=&source=LinkedIn"}><FontAwesomeIcon icon={faLinkedinIn} aria-hidden="true" /></a>
                <a rel="noreferrer" aria-label="Share via email" href={"mailto:?subject="+title+"&body=Check%20out%20this%20article%20"+link}><FontAwesomeIcon icon={faEnvelope} aria-hidden="true" /></a>
              </div>
            </div>
            <div className="col-sm-4">
              <Sidebar posts={mostRecent} />
            </div>
          </div>
        </div>
        <RelatedPosts relatedPosts={selectedPosts} />
      </Layout>
    )
  }
}

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
}

export default PostTemplate

/**
 * Gatsby Head API export — puts the JSON-LD into the real <head> of the
 * statically rendered HTML, where crawlers that do not execute JavaScript can
 * read it. Additive: the inline <Head> meta rendering is untouched.
 *
 * The blog had no schema of any kind before this (GTM covered six hand-built
 * pages, none of them posts), so every post gains BlogPosting markup.
 */
export const Head = ({ data }) => {
  const post = data?.wpPost
  if (!post) return null

  const { seo, title, uri, link, dateIso, modifiedIso, featuredImage, categories } = post
  const url = uri || link
  // Prefer the locally served copy over WordPress's sourceUrl: sourceUrl points
  // at admin.roanokegroup.com (the CMS backend), which would put the backend
  // domain into structured data and break if admin access is ever restricted.
  // publicURL is content-hashed, so it only changes when the image does.
  const articleImage =
    featuredImage?.node?.localFile?.publicURL || featuredImage?.node?.sourceUrl || null

  // 231 of 676 posts have no featured image. Deliberately NOT falling back to
  // the org logo for the article itself — the logo is not a picture of the
  // article, and asserting it across hundreds of posts is a weak signal. The
  // GTM Article nodes carried no image at all, so omitting matches the
  // baseline. The WebPage node keeps the logo as primaryImageOfPage, which is
  // what GTM did on all six pages.
  const pageImage = articleImage || LOGO_URL
  const category = categories?.nodes?.[0]

  return (
    <JsonLd
      graph={[
        organizationNode(),
        websiteNode(),
        webPageNode({
          url,
          name: seo?.title || title,
          description: seo?.metaDesc,
          datePublished: dateIso,
          dateModified: modifiedIso,
          imageUrl: pageImage,
        }),
        breadcrumbNode([
          { name: 'Home', url: '/' },
          { name: 'News & Insights', url: '/blog/' },
          // Use the category's own uri from WPGraphQL — categories live at
          // /blog/category/<slug>/, not /category/<slug>/.
          ...(category?.uri ? [{ name: category.name, url: category.uri }] : []),
          { name: title, url },
        ]),
        articleNode({
          type: 'BlogPosting',
          url,
          headline: title,
          description: seo?.metaDesc || post.excerpt,
          datePublished: dateIso,
          dateModified: modifiedIso,
          imageUrl: articleImage,
        }),
      ]}
    />
  )
}

export const pageQuery = graphql`
  query ($id: String!, $relatedCategoryId: [String]) {
  wpPost(id: {eq: $id}) {
    id
    link
    title
    excerpt
    content
    seo {
      ...seoParts
    }
    date(formatString: "MMMM DD, YYYY")
    # Aliased ISO-8601 copies for JSON-LD — schema.org requires ISO, while the
    # unaliased date field above stays in display format for the rendered page.
    dateIso: date
    modifiedIso: modified
    uri
    categories {
      nodes {
        name
        slug
        uri
      }
    }
    featuredImage {
      node {
        altText
        sourceUrl
        modified
        localFile {
          publicURL
          childImageSharp {
            gatsbyImageData(
              width: 1200
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
      }
    }
  }

  mostRecent: allWpPost (sort: {date: DESC}, limit: 5) {
    nodes {
      id
      title
      link
      excerpt
      date(formatString: "MMMM DD, YYYY")
      categories {
        nodes {
          name
        }
      }
      featuredImage {
        node {
          altText
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 400
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
  }

  relatedPosts: allWpPost(
    sort: {date: DESC}
    limit: 15
    filter: {categories: {nodes: {elemMatch: {id: {in: $relatedCategoryId}}}}}
  ) {
    nodes {
      id
      title
      link
      excerpt
      date(formatString: "MMMM DD, YYYY")
      categories {
        nodes {
          id
          name
        }
      }
      featuredImage {
        node {
          altText
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 400
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
  }

}
`
